import { render } from "./ContractsList.vue?vue&type=template&id=8b6831ae&scoped=true"
import script from "./ContractsList.vue?vue&type=script&lang=js"
export * from "./ContractsList.vue?vue&type=script&lang=js"

import "./ContractsList.vue?vue&type=style&index=0&id=8b6831ae&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6831ae"]])

export default __exports__